import { type DisplayDocument, Document } from '@startuptools/business-ui/document/Document';
import {
  GqlDocumentSignatureMethod,
  type GqlIdentity,
  type GqlMeetingParticipant,
} from '../../../../graphql/base-types.graphql';
import { useDocGenPowerOfAttorneyMutation } from '../../../../graphql/react-operations';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { PowerOfAttorneysDocument } from '../../../shareholders-meetings/components/edit-steps/PowerOfAttorneys.graphql';

export const PowerOfAttorney = ({
  meetingParticipant,
}: {
  meetingParticipant: Pick<GqlMeetingParticipant, 'id'> & {
    identity: Pick<GqlIdentity, 'name'>;
    proxy?: Pick<GqlIdentity, 'name'> | null;
    latestPowerOfAttorney?: DisplayDocument | null;
  };
}) => {
  const companyId = useCompanyId();

  // eslint-disable-next-line sut/loading-mutation
  const [doGenerate] = useDocGenPowerOfAttorneyMutation({
    refetchQueries: [PowerOfAttorneysDocument],
  });

  // const defaultFilename = getDefaultFilename(optionsRegistration, warrantProgram, company);
  const defaultFilename = `Fullmakt ${meetingParticipant.identity.name} - ${meetingParticipant.proxy?.name}.pdf`;

  return (
    <>
      <Document
        allowDigitalSignature={false}
        document={meetingParticipant.latestPowerOfAttorney}
        defaultFileName={defaultFilename}
        generate={async () => {
          return doGenerate({
            variables: {
              companyId,
              meetingParticipantId: meetingParticipant.id,
              signatureMethod: GqlDocumentSignatureMethod.Analogue,
            },
          });
        }}
      />
    </>
  );
};
